import { getDashboardFilters, getInitialDashboardFilters } from '@domain/dashboard/dashboard-filters/dashboard-filters.state';
import { getInitialMetrics } from '@domain/dashboard/metrics-report/metrics-report.state';
import { getObjectSelectedData, getObjectSelectedFields } from '@domain/object-selected';
import { createMiddleware } from '@shared/redux/create-middleware';
import {
    CHANGE_BIG_NUMBERS,
    CHANGE_CAMPAIGN_FILTER,
    editUserConfig,
    getUserConfigData,
    GET_USER_CONFIG_REQUEST_SUCCEEDED,
} from './user-config.state';

export const userConfigMiddlewares = createMiddleware({
    [GET_USER_CONFIG_REQUEST_SUCCEEDED]: () => [
        getInitialDashboardFilters(),
        getInitialMetrics(),
    ],
    [CHANGE_CAMPAIGN_FILTER]: (state, action) => {
        const dashboardFilters = getUserConfigData(state).DASHBOARD_FILTERS || {};

        const newFilters = {
            ...dashboardFilters,
            userLevel: {
                ...dashboardFilters.userLevel,
                campaignTableMetrics: action.payload.campaignTableMetrics,
            },
        };

        return editUserConfig({
            configs: {
                DASHBOARD_FILTERS: newFilters,
            },
        });
    },
    [CHANGE_BIG_NUMBERS]: (state, action) => {
        const userCongif = getUserConfigData(state);

        const currentFilters = getDashboardFilters(state);
        const dashboardFilters = userCongif.DASHBOARD_FILTERS || {};
        const objectSelectedData = getObjectSelectedData(state);
        const { entity, id } = getObjectSelectedFields(objectSelectedData);
        const entityFilter = dashboardFilters[entity] || {};

        const { bigNumbers } = action.payload;

        const newBigNumbersConfig = {
            ...userCongif.BIG_NUMBER,
            ...bigNumbers,
        };

        const newEntityFiltersForId = {
            ...currentFilters,
            bigNumbers: newBigNumbersConfig,
        };

        const newFilters = {
            ...dashboardFilters,
            [entity]: {
                ...entityFilter,
                [id]: newEntityFiltersForId,
            },
        };

        return editUserConfig({
            configs: {
                BIG_NUMBER: newBigNumbersConfig,
                DASHBOARD_FILTERS: newFilters,
            },
        });
    },
});
